import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as PAYROLLACTIONS } from "../../../store/actions/payrollActions";
import { format, addYears, set, parse } from "date-fns";
import DatePicker from "react-datepicker";
import { DateInputFormat, handleRawDate } from "@/components/common/DateComponents";
import BuddySelector from "@/components/common/custom-selectors/BuddySelector";
import { bankTypes } from "@/common/variables/bankTypes";

const UKDownloadOptions = [
	{ label: "BACS Standard 18", value: "TXT" },
	{ label: "BACS XML", value: "XML" },
];

const DownloadSepa = ({ bank, period, downloadSepaFile, jurisdiction, bankDetails }) => {
	const today = format(new Date(), "yyyy-MM-dd");
	const [transferDate, setTransferDate] = useState(today);
	const [fileType, setFileType] = useState("TXT");

	const { custCode, fileRef } = bankDetails;

	useEffect(() => {
		if (period) {
			const payDate = parse(period?.payDay, "yyyy-MM-dd", new Date());
			setTransferDate(payDate > today ? payDate : today);
		}
	}, [period]);

	const validateSepa = () => {
		downloadSepaFile(bank, fileType, {
			period: period?.id,
			executionDate: transferDate,
			custCode,
			fileRef,
		});
	};

	return (
		<div className="form-group mx-12 mt-12">
			<div className="form-material col-xs-6 pl-0">
				<label>Transfer Date</label>
				<DatePicker
					selected={transferDate && new Date(transferDate)}
					minDate={today}
					maxDate={addYears(new Date(), 100)}
					dateFormat="dd/MM/yyyy"
					wrapperClassName="full-width"
					onChange={(newRenewalDate) => {
						if (newRenewalDate) setTransferDate(format(newRenewalDate, "yyyy-MM-dd"));
					}}
					customInput={<DateInputFormat />}
					onChangeRaw={(e) =>
						handleRawDate(e.target.value, (newRenewalDate) => {
							setTransferDate(format(newRenewalDate, "yyyy-MM-dd"));
						})
					}
					strictParsing
				/>
			</div>
			{jurisdiction === "UK" && (
				<div className="col-xs-6 form-material pl-0">
					<label>Type</label>
					<BuddySelector
						options={UKDownloadOptions}
						onChange={(v) => setFileType(v.value)}
						value={UKDownloadOptions.find((o) => o.value === fileType)}
					/>
				</div>
			)}
			<div className="clearfix" />
			<button
				className="btn btn-success pull-right mb-12 mr-5"
				onClick={(e) => {
					e.preventDefault();
					validateSepa();
				}}
			>
				Generate Bank File
			</button>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const bankDetails = state.company?.settings?.bankDetails?.[0];
	const bank = bankTypes?.find((b) => b.bic === bankDetails?.bic)?.name || "hsbc";
	return {
		bank,
		period: state?.company?.bankTransferModal?.period,
		jurisdiction: state.company?.settings?.jurisdiction,
		bankDetails,
	};
};

const mapDispatchToProps = (dispatch) => ({
	downloadSepaFile: (bank, fileType, params) => dispatch(PAYROLLACTIONS.downloadSepaFile(bank, fileType, params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadSepa);
